// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2X7cl","log":"ModalInventoryLogs_log__WpDRL","date":"ModalInventoryLogs_date__1D8mB","userName":"ModalInventoryLogs_userName__34cPy"};